import { FC } from 'react';

import { useTitle } from '../hooks/useTitle';

import FindPassword from 'src/components/templates/FindPassword/FindPassword';

const FindPasswordPage: FC = () => {
  useTitle('GU | 비밀번호 찾기');
  return <FindPassword />;
};

export default FindPasswordPage;
